export const CURRENCY_SYMBOLS = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥'
};

export const formatNumber = (num, decimals = 2) => {
    if (num === null || num === undefined) return 'N/A';
    return Number(num).toLocaleString('de-DE', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    });
};

export const formatCurrencyValue = (value, currency) => {
    if (value === null || value === undefined) return 'N/A';
    const symbol = CURRENCY_SYMBOLS[currency] || currency || '€';
    return `${symbol}${formatNumber(value)}`;
};

export const formatBillionWithCurrency = (num, currency) => {
    if (num === null || num === undefined) return 'N/A';
    const symbol = CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS['EUR'] || '€';
    return `${symbol}${(Number(num) / 1000000000).toFixed(2)}B`;
};

export const formatBillionValue = (value, currency) => {
    if (value === null || value === undefined) return 'N/A';

    const billion = 1000000000;
    const million = 1000000;

    if (value >= billion) {
        return `${(value / billion).toLocaleString('de-DE', { maximumFractionDigits: 2 })} Mrd. ${currency}`;
    } else {
        return `${(value / million).toLocaleString('de-DE', { maximumFractionDigits: 2 })} Mio. ${currency}`;
    }
};
